export function ensureError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  if (error && typeof error === 'object' && 'error' in error) {
    if (error.error instanceof Error) {
      return error.error;
    }
    if (
      typeof error.error === 'object' &&
      error.error &&
      'message' in error.error
    ) {
      return new Error(String(error.error.message));
    }
    if (typeof error.error === 'string') {
      return new Error(error.error);
    }
  }
  return new Error(`Unknown error: ${error}`);
}
